// extracted by mini-css-extract-plugin
export default {"wrap":"BookingCommentBlock_wrap__OAOuZ","container":"BookingCommentBlock_container__RB5ly","commentView":"BookingCommentBlock_commentView__x57lj"};